import React, { useState } from 'react';
const faqs = [{
  q: 'Est-ce adapté aux niveaux débutants ?',
  a: 'Oui, le pack inclut des volumes spécifiques dès les U10 avec des progressions graduelles pour chaque catégorie.'
}, {
  q: 'Le Kit Tactique est-il en vidéo ?',
  a: 'Non, ce sont des outils visuels en PDF HD conçus pour une visualisation rapide sur tablette, mobile ou en version imprimée.'
}, {
  q: 'Que faire si mes joueurs ont des niveaux mélangés ?',
  a: 'Le système inclut des variantes de complexité pour chaque exercice, faciles à adapter au groupe que vous avez sur le terrain.'
}, {
  q: 'Comment vais-je recevoir le matériel ?',
  a: "Accès immédiat par email après l'achat. Tout en PDF téléchargeable, prêt à utiliser dès le premier entraînement."
}, {
  q: 'Est-ce adapté si je suis un entraîneur débutant ?',
  a: "Oui, c'est conçu pour partir de zéro. Vous ouvrez le volume, vous lisez 3 minutes et vous entrez sur le terrain avec tout en main."
}, {
  q: 'Y a-t-il une vraie garantie ?',
  a: "7 jours sans questions. 100% de votre argent remboursé si ce n'est pas ce que vous attendiez."
}, {
  q: "Puis-je l'utiliser à la fois en école et en club ?",
  a: "Oui. Le matériel est pensé pour les cours d'EPS et pour les entraînements de club. Les séances s'adaptent à 40, 60 ou 80 minutes."
}, {
  q: "Faut-il une expérience préalable en handball pour l'appliquer ?",
  a: "Non. Chaque exercice inclut les objectifs, l'organisation de l'espace, des variantes et des points clés de correction. C'est un système guidé, étape par étape."
}, {
  q: 'Cela fonctionne-t-il sur mobile et tablette ?',
  a: 'Oui, tous les PDF sont optimisés pour être lus sur mobile, tablette ou ordinateur. Vous pouvez aussi les imprimer en haute qualité pour les apporter au gymnase.'
}, {
  q: 'Vais-je recevoir les mises à jour futures ?',
  a: 'Oui. Une fois acheté, vous accédez gratuitement aux prochaines améliorations et aux nouvelles séances que nous ajoutons au Pack Complet.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-main py-24 px-4" data-id="element-103">
      <div className="max-w-3xl mx-auto" data-id="element-104">
        <h2 className="text-3xl sm:text-5xl font-black text-text-main text-center mb-12 tracking-tight" data-id="element-105">
          Questions Fréquentes
        </h2>

        <div className="space-y-4 mb-16" data-id="element-106">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-bg-alt border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-primary/50 shadow-[0_0_20px_rgba(59,130,246,0.1)]' : 'border-border-light hover:border-white/20'}`} data-id="element-107">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-108">
                  <span className={`font-bold text-lg transition-colors ${isOpen ? 'text-primary' : 'text-text-main'}`} data-id="element-109">
                    {faq.q}
                  </span>
                  <span className={`text-2xl flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-45 text-primary' : 'text-text-sec'}`} data-id="element-110">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-60 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-111">
                  <p className="text-text-sec text-base leading-relaxed" data-id="element-112">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center relative" data-id="element-113">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-cta-green/20 blur-[80px] pointer-events-none rounded-full" data-id="element-114"></div>
          <a href="#pricing" className="relative btn-primary-pulse bg-cta-green font-black text-lg sm:text-2xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-all inline-block mb-4 w-full sm:w-auto max-w-2xl text-white shadow-[0_0_30px_rgba(16,185,129,0.3)] border border-white/20" data-id="element-115">
            🚀 OUI ! JE VEUX AMÉLIORER MA CARRIÈRE MAINTENANT
          </a>
          <p className="text-text-sec text-sm font-medium flex items-center justify-center gap-2" data-id="element-116">
            <span data-id="element-117">⚡ Accès Immédiat</span>
            <span data-id="element-118">•</span>
            <span data-id="element-119">🛡️ Garantie de 7 Jours</span>
          </p>
        </div>
      </div>
    </section>;
}